import { Upload } from "tus-js-client";
import { Vimeo_axios_adapter } from "./Vimeo_axios_adpter";
import { VIMEO_BASE_URL, VIMEO_ENDPOINTS } from "./Vimeo_Constant";

let onProgressCallback = null;

export const setOnProgressCallback = (callback) => {
  onProgressCallback = callback;
};

export const uploadVideoToVimeo = async (file, bucket, title = "Untitled", description = "") => {
  try {
    // Step 1: Create a Vimeo video upload session
    const createRes = await Vimeo_axios_adapter.post(VIMEO_ENDPOINTS.VIDEOS, {
      upload: {
        approach: "tus",
        size: file.size,
      },
      name: title,
      description,
    });

    const uploadLink = createRes.data.upload.upload_link;
    const videoUri = createRes.data.uri;

    // Step 2: Upload the video using tus-js-client with uploadUrl
    return new Promise((resolve, reject) => {
      const upload = new Upload(file, {
        uploadUrl: uploadLink,
        retryDelays: [0, 1000, 3000],
        metadata: {
          filename: file.name,
          filetype: file.type,
        },
        uploadSize: file.size,
        onError: (error) => {
          console.error("Upload failed:", error);
          reject({ success: false, error });
        },
        onProgress: (bytesUploaded, bytesTotal) => {
          const percent = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
          console.log(`Upload progress: ${percent}%`);
          if (onProgressCallback) onProgressCallback(percent);
        },
        onSuccess: async () => {
          console.log("Upload complete:", upload.url);

          // Step 3: Move video to specific folder/project
          try {
            const finalurlToUpload = `${bucket}${videoUri}`;
            console.log("finalurlToUpload : ", finalurlToUpload)
            await Vimeo_axios_adapter.put(finalurlToUpload);
            console.log("Video moved to Staging folder.");
          } catch (moveErr) {
            console.warn("Video uploaded but failed to move to folder:", moveErr);
          }

          resolve({ success: true, videoUri });
        },
      });

      upload.start();
    });
  } catch (error) {
    console.error("Vimeo upload error:", error);
    return { success: false, error };
  }
};

export const extractVimeoId = (url) => {
    try {
        var patterns = [
            /(?:api\.vimeo\.com\/videos\/([0-9]+))/,
            /(?:vimeo\.com\/(?:.*#|.+\/videos\/)?([0-9]+))/,
            /(?:player\.vimeo\.com\/video\/([0-9]+))/,
            /^([0-9]+)$/
        ];

        for (var i = 0; i < patterns.length; i++) {
            var match = url.match(patterns[i]);
            if (match && match[1]) {
                return match[1];
            }
        }
        return null;
    } catch (error) {
        return null;
    }
}

export async function getVimeoPlayLink(videoId) {
    try {
        console.log(`getVimeoPlayLink: Fetching progressive play link for video ID: ${videoId}`);

        const response = await Vimeo_axios_adapter.get(`/videos/${videoId}`);

        //console.log(`getVimeoPlayLink: Response structure: ${JSON.stringify(response.data?.play, null, 2)}`);

        const progressiveVideos = response?.data?.play?.progressive || response?.data?.player_embed_url;

        if (progressiveVideos && Array.isArray(progressiveVideos) && progressiveVideos.length > 0) {
            const progressiveLink = progressiveVideos[0]?.link;
            if (progressiveLink) {
                console.log(`getVimeoPlayLink: Successfully retrieved progressive link for video ${videoId}`);
                return {progressiveLink,videoData : response?.data};
            }
        }

        const playLink = response?.data?.play?.link || response?.data?.play?.player_embed_url;
        if (playLink) {
            console.log(`getVimeoPlayLink: Successfully retrieved regular play link for video ${videoId}`);
            return {playLink,videoData : response?.data};
        }

        console.log(`getVimeoPlayLink: No progressive or play link found in response for video ${videoId}`);
        console.log(`getVimeoPlayLink: Available response data: ${JSON.stringify(response.data, null, 2)}`);
        return null;

    } catch (error) {
        console.log(`getVimeoPlayLink: Failed to fetch video ${videoId} - ${error.message}`);
        return null;
    }
}

export async function getVimeoPlayLink2(videoId) {
    try {
        console.log(`getVimeoPlayLink: Fetching progressive play link for video ID: ${videoId}`);

        const response = await Vimeo_axios_adapter.get(`/videos/${videoId}`);

        const progressiveLink = response?.data?.player_embed_url;

         return {progressiveLink,videoData : response?.data,playLink:null};

    } catch (error) {
        console.log(`getVimeoPlayLink: Failed to fetch video ${videoId} - ${error.message}`);
        return null;
    }
}
